import { Typography } from '@mui/material';
import React, { useState, useEffect, useContext } from 'react';
import Content from '../components/Layout/Content';
import { Box } from '@mui/system';
import ReusableTable from '../components/ReusableTable/ReusableTable';
import {
  carePlanArrayConvertor,
  calculateDateFilterTimeStamp,
} from '../shared/helper';
import { useLocation } from 'react-router-dom';
import NotFound from '../components/NotFound/NotFoundPage';
import { useLazyQuery } from '@apollo/client';
import { useSnackbar } from 'notistack';
import FilterDropDown from '../components/filterDropDown/FilterDropDown';
import SearchBar from '../components/SearchBar/Search';
import PaginationComponent from '../components/paginationComponent/ServerSidePaginationComponent';
import {
  careplansStatusFilterDatas,
  DEFAULT_NULL_REPLACEMENT,
  NUMBER_OF_ROWS_PER_PAGE,
  dateFilterMenuItems,
} from '../shared/constants';
import { getIconFromSubItemsArray } from '../shared/helper';
import ApplicationContext from '../context/applicationContext';
import { BreadcrumbComponent } from '../components/BreadcrumbComponent/BreadcrumbComponent';
import {
  FETCH_ALL_CAREPLANS_QUERY,
  FETCH_CAREPLANS_BY_ID_QUERY,
} from '../services/CarePlansQueries/CarePlansService';
import { SimpleBackdrop } from '../components/SimpleBackdropComponent/SimpleBackdrop';
import { ServiceFlyout } from '../components/ServiceFlyout/ServiceFlyout';
import CarePlanComponent from '../components/CarePlanComponent/CarePlanComponent';
import {
  CAREPLANS,
  CAREPLANS_TABLE_HEADING as tableHeading,
  CAREPLANS_BREADCRUMBDATA as breadcrumbData,
} from '../shared/Strings';

const table = {
  marginTop: 8,
  '& .css-1kn3lhz': {},
};

export const CarePlans = () => {
  const [searchValue, setSearchValue] = useState('');
  const [recordsData, setRecordedData] = React.useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [timeFilter, setTimeFilter] = React.useState('all');
  const [statusFilter, setStatusFilter] = React.useState('all');
  const [openFlyout, setOpenFlyout] = useState(false);
  const [detailsData, setDetailsData] = useState([]);
  const [selectedTableId, setSelectedTableId] = useState(null);
  const [modalTitle, setModalTitle] = useState('');
  const [carePlanflyoutData, setCarePlanflyoutData] = useState();
  const [totalCount, setTotalCount] = useState();
  const [offset, setOffset] = useState(0);
  const [careTeamData, setCareTeamData] = useState([]);
  const { menuItems } = useContext(ApplicationContext);
  const { enqueueSnackbar } = useSnackbar();
  const { state } = useLocation();

  const [fetchAllCarePlans, fetchAllCarePlansCall] = useLazyQuery(
    FETCH_ALL_CAREPLANS_QUERY,
    {
      fetchPolicy: 'cache-and-network',
      onError: err => {
        enqueueSnackbar(CAREPLANS.ON_ERROR_TEXT.WENT_WRONG_TEXT, {
          variant: 'error',
        });
      },
      onCompleted: res => {
        let result = res.fetchAllCarePlans.carePlanList;
        let parseResult = JSON.parse(result);
        let data = carePlanArrayConvertor(parseResult);
        setRecordedData(data);
        setFilteredData(data);
        setTotalCount(res.fetchAllCarePlans.count);
      },
    }
  );

  const [fetchCarePlansById, fetchCarePlansByIdCall] = useLazyQuery(
    FETCH_CAREPLANS_BY_ID_QUERY,
    {
      fetchPolicy: 'cache-and-network',
      onError: err => {
        enqueueSnackbar(CAREPLANS.ON_ERROR_TEXT.BY_ID, {
          variant: 'error',
        });
      },
      onCompleted: res => {
        showFlyout(res.fetchCarePlanById);
      },
    }
  );

  useEffect(() => {
    if (recordsData.length !== 0 && state !== null) {
      let selectedPlan = recordsData.find(obj => obj.careplan === state);
      viewDetailsHandler(selectedPlan.id);
    }
  }, [recordsData, state]);

  useEffect(() => {
    fetchAllCarePlans({
      variables: {
        sourceUrl: '',
        count: NUMBER_OF_ROWS_PER_PAGE.toString(),
        offset: offset,
        dateFilter: calculateDateFilterTimeStamp(timeFilter) || 0,
        statusFilter: statusFilter === 'all' ? '' : statusFilter,
        searchFilter: '',
      },
    });
  }, [offset, statusFilter, timeFilter]);

  const onPageClick = pageNumber => {
    setOffset((pageNumber - 1) * 10);
  };

  const closeFlyout = () => {
    setOpenFlyout(false);
  };

  const onSearch = text => {
    setSearchValue(text);
  };

  const handleChangeFilter = () => {
    setOffset(0);
  };

  const dateFilterOptions = {
    options: dateFilterMenuItems,
    value: timeFilter,
    changeHandler: ev => {
      setTimeFilter(ev.target.value);
      handleChangeFilter();
    },
  };
  const statusFilterOptions = {
    options: careplansStatusFilterDatas,
    value: statusFilter,
    changeHandler: ev => {
      setStatusFilter(ev.target.value);
      handleChangeFilter();
    },
  };

  const showFlyout = result => {
    const tableRowInfo = recordsData.find(obj => obj.id === selectedTableId);
    const modalData = [
      {
        column_name: CAREPLANS.MODAL_DATA.STATUS,
        value: tableRowInfo?.status || DEFAULT_NULL_REPLACEMENT,
        width: 5,
      },
      {
        column_name: CAREPLANS.MODAL_DATA.RECORDED_ON,
        value: tableRowInfo?.recordedOn || DEFAULT_NULL_REPLACEMENT,
        width: 7,
      },

      {
        column_name: CAREPLANS.MODAL_DATA.RECORDED_BY,
        value: result?.author?.display || DEFAULT_NULL_REPLACEMENT,
        width: 5,
      },
      {
        column_name: CAREPLANS.MODAL_DATA.FACILITY,
        value: result?.contributor?.[0]?.display || DEFAULT_NULL_REPLACEMENT,
        width: 7,
      },
    ];

    let carePlanflyoutDataLocal = {
      problems: [],
      goals: [],
      activitics: [],
    };
    result?.activity
      ? result?.activity.map((val, index) =>
          carePlanflyoutDataLocal.activitics.push(
            val?.detail?.code?.coding?.[0]?.display || DEFAULT_NULL_REPLACEMENT
          )
        )
      : carePlanflyoutDataLocal.activitics.push(DEFAULT_NULL_REPLACEMENT);

    result?.addresses
      ? result?.addresses.map((val, index) =>
          carePlanflyoutDataLocal.problems.push(val?.display)
        )
      : carePlanflyoutDataLocal.problems.push(DEFAULT_NULL_REPLACEMENT);

    result?.goal
      ? result.goal.map((val, index) =>
          carePlanflyoutDataLocal?.goals?.push(
            JSON.parse(val?.display)['description']
          )
        )
      : carePlanflyoutDataLocal.goals.push(DEFAULT_NULL_REPLACEMENT);

    const CareTeamFlyoutData = {
      data: result?.careTeam || null,
    };
    setCareTeamData(CareTeamFlyoutData);
    setCarePlanflyoutData(carePlanflyoutDataLocal);
    setDetailsData(modalData);
    setOpenFlyout(true);
  };

  const viewDetailsHandler = id => {
    setSelectedTableId(id);
    const tableRowInfo = recordsData.find(obj => obj.id === id);
    setModalTitle(tableRowInfo.careplan);
    fetchCarePlansById({
      variables: {
        carePlanId: id,
      },
    });
  };

  return (
    <Content>
      <BreadcrumbComponent
        breadcrumbData={breadcrumbData}></BreadcrumbComponent>
      <Typography variant="title">{CAREPLANS.TITLE_TEXT}</Typography>
      <Box sx={{ display: 'flex', position: 'relative', top: 40 }}>
        {/* <SearchBar
          sx={{
            width: '50%',
            minWidth: '250px',
            maxWidth: '500px',
            marginTop: '8px',
          }}
          onSearch={onSearch}
          placeholder={CAREPLANS.SEARCH_PLACEHOLDER_TEXT}
        /> */}
        <FilterDropDown {...dateFilterOptions} filterType="Date:" />
        <FilterDropDown {...statusFilterOptions} filterType="Status:" />
      </Box>
      <Box sx={table}>
        {!fetchAllCarePlansCall.loading && !filteredData.length ? (
          <NotFound title={CAREPLANS.TITLE_TEXT} />
        ) : (
          <>
            <ReusableTable
              tableHeading={tableHeading}
              data={filteredData}
              viewDetailsHandler={viewDetailsHandler}
            />
            <div
              style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                marginTop: 18,
              }}>
              {totalCount > NUMBER_OF_ROWS_PER_PAGE && (
                <PaginationComponent
                  numberOfRowsPerPage={NUMBER_OF_ROWS_PER_PAGE}
                  count={totalCount}
                  onPageClick={onPageClick}
                  page={offset / 10}
                />
              )}
            </div>
          </>
        )}
      </Box>

      <ServiceFlyout
        isOpen={openFlyout}
        handleClose={closeFlyout}
        data={detailsData}
        icon={
          menuItems
            ? getIconFromSubItemsArray(menuItems?.Care?.subItems, 'Care Plans')
            : null
        }
        careTeamData={careTeamData}
        category="Care Plans"
        title={modalTitle}>
        <CarePlanComponent
          carePlanflyoutData={carePlanflyoutData}
          careTeamData={careTeamData}
        />
      </ServiceFlyout>
      <SimpleBackdrop
        open={fetchAllCarePlansCall.loading || fetchCarePlansByIdCall.loading}
      />
    </Content>
  );
};
